import { useCallback, useEffect, useRef } from 'react'

// Coalesces a burst of events into one call per painted frame.
//
// Scroll, resize and visualViewport events can fire several times in a single
// frame - and on two windows at once when the widget is embedded - while the
// measurement they trigger is only worth taking once per frame. The pending
// frame is canceled on unmount so a queued callback never runs against a
// component that has gone away.
const useFrameCoalescedCallback = (callback) => {
  const pendingFrame = useRef(null)

  const schedule = useCallback(() => {
    if (pendingFrame.current !== null) {
      return
    }
    pendingFrame.current = requestAnimationFrame(() => {
      pendingFrame.current = null
      callback()
    })
  }, [ callback ])

  useEffect(() => () => {
    if (pendingFrame.current !== null) {
      cancelAnimationFrame(pendingFrame.current)
      pendingFrame.current = null
    }
  }, [])

  return schedule
}

export default useFrameCoalescedCallback
